<ng-container *ngIf="showForm; else success">
  <p>{{ I18ns.addTheme.title }}</p>

  <div [formGroup]="form" class="form">
    <label for="email">{{ I18ns.addTheme.email }} *</label>
    <input formControlName="email" id="email" placeholder="test@me.com" type="email" />
    <p class="explain">{{ I18ns.addTheme.emailExplained }}</p>
    <hr />

    <label for="name">{{ I18ns.addTheme.name }} *</label>
    <input formControlName="name" id="name" maxlength="32" placeholder="Places" type="text" />
    <p class="explain">{{ I18ns.addTheme.nameExplained }}</p>
    <hr />

    <label>{{ I18ns.addTheme.lang }}</label>

    <div (click)="showLangs = !showLangs" class="lang-picker">
      {{ form.value.lang }}

      <div *ngIf="showLangs" class="lang-options">
        <div (click)="pickLang(null)" class="options">{{ I18ns.addTheme.noLang }}</div>
        <div (click)="pickLang(lang)" *ngFor="let lang of flagList" class="options">
          {{ lang.flag }} {{ lang.tag }}
        </div>
      </div>
    </div>

    <hr />

    <label for="words">{{ I18ns.addTheme.words }} *</label>
    <textarea formControlName="words" id="words" placeholder="first,second,third,fourth"></textarea>
    <hr />

    <label for="comments">{{ I18ns.addTheme.comments }}</label>
    <input formControlName="comments" id="comments" maxlength="200" type="text" />
    <p class="explain">{{ I18ns.addTheme.commentsExplained }}</p>

    <div (click)="form.valid && save()" class="btn">{{ I18ns.addTheme.save }}</div>

    <p>&nbsp;</p>
  </div>
</ng-container>

<ng-template #success>
  <p class="mb-2">{{ I18ns.addTheme.success }}</p>
  <a [routerLink]="['/k', createdTheme?.id]" class="btn mb-2">{{ createdTheme?.name }}</a>
  <p class="mb-2">{{ I18ns.addTheme.success2 }}</p>
  <input [style.width]="'100%'" [value]="URL + '/k/' + createdTheme?.id" class="mb-2" type="text" />
  <div class="mb2">
    <a
      [href]="'mailto:?body=' + I18ns.addTheme.shareMail + URL + '/k/' + createdTheme?.id"
      class="btn"
      style="margin-right: 1rem"
      target="_blank"
    >
      <svg
        fill="#ffffff"
        height="30px"
        viewBox="0 -960 960 960"
        width="24px"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z"
        />
      </svg>
    </a>
    <a (click)="copyLink()" class="btn">
      <svg
        fill="#ffffff"
        height="30px"
        viewBox="0 -960 960 960"
        width="24px"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M680-80q-50 0-85-35t-35-85q0-6 3-28L282-392q-16 15-37 23.5t-45 8.5q-50 0-85-35t-35-85q0-50 35-85t85-35q24 0 45 8.5t37 23.5l281-164q-2-7-2.5-13.5T560-760q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35q-24 0-45-8.5T598-672L317-508q2 7 2.5 13.5t.5 14.5q0 8-.5 14.5T317-452l281 164q16-15 37-23.5t45-8.5q50 0 85 35t35 85q0 50-35 85t-85 35Zm0-80q17 0 28.5-11.5T720-200q0-17-11.5-28.5T680-240q-17 0-28.5 11.5T640-200q0 17 11.5 28.5T680-160ZM200-440q17 0 28.5-11.5T240-480q0-17-11.5-28.5T200-520q-17 0-28.5 11.5T160-480q0 17 11.5 28.5T200-440Zm480-280q17 0 28.5-11.5T720-760q0-17-11.5-28.5T680-800q-17 0-28.5 11.5T640-760q0 17 11.5 28.5T680-720Zm0 520ZM200-480Zm480-280Z"
        />
      </svg>
    </a>
  </div>
</ng-template>
